import title from 'components/seo/title';
import { useConfig } from 'config/use-config';
import { NextPage } from 'next';
import Head from 'next/head';
import NextLink from 'next/link';
import { FormattedMessage, useIntl } from 'react-intl';

const NotFound: NextPage = () => {
  const intl = useIntl();
  const { commonPagePaths } = useConfig();

  return (
    <>
      <Head>
        {title(
          intl.formatMessage({
            id: 'error:page:page-title:page-not-found',
          })
        )}
      </Head>
      <div
        className="container mb-10 flex flex-col items-center justify-center py-10"
        style={{ minHeight: '40vh' }}
      >
        <div className="flex flex-col">
          <NextLink href="/" aria-label="Pets Deli" className="mr-auto mb-4 lg:mr-0">
            <img
              src="/images/petsdeli-logo.svg"
              className="w-auto"
              alt="Pets Deli"
              role="presentation"
            />
          </NextLink>

          <h1 className="text-primary-main text-3xl font-black">
            <FormattedMessage id="error:page:header" />
          </h1>
          <p className="text-primary-main py-4">
            <FormattedMessage id="error:page:suggestions:header" />
          </p>
          <NextLink href="/" className="text-brand-blue-neu mb-3 underline">
            <FormattedMessage id="error:page:suggestions:home" />
          </NextLink>
          <NextLink
            href={commonPagePaths.foodConsultation}
            className="text-brand-blue-neu mb-3 underline"
          >
            <FormattedMessage id="error:page:suggestions:foodaid" />
          </NextLink>
          <NextLink href="/account" className="text-brand-blue-neu mb-3 underline">
            <FormattedMessage id="error:page:suggestions:account" />
          </NextLink>

          <NextLink href="/cart" className="text-brand-blue-neu mb-3 underline">
            <FormattedMessage id="error:page:suggestions:cart" />
          </NextLink>
        </div>
      </div>
    </>
  );
};

export default NotFound;
